export const AddIcon = ({ color = "#DBBE78", size = 16, ...props }) => (
    <svg
        width={size}
        height={size * (15 / 16)}
        viewBox="0 0 16 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <line x1="12.3496" y1="7.54297" x2="3.64961" y2="7.54297" stroke={color} />
        <line x1="7.79102" y1="11.6826" x2="7.79102" y2="2.98262" stroke={color} />
        <circle cx="8" cy="7.33301" r="6.75" transform="rotate(90 8 7.33301)" stroke={color} />
    </svg>
);
